/**
 * Fixed Sticky
 */


// Using the polyfill instead of native
FixedSticky.tests.sticky = false;



// Initialize sticky nodes
(function($) {

    $('.js-fixedsticky').fixedsticky();

})(jQuery);
